import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DeviceDetectionService {
    private readonly isMobile: boolean;

    constructor() {
        this.isMobile = this.checkIfMobile();
    }

    private checkIfMobile(): boolean {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;

        // Check for mobile devices
        if (/android/i.test(userAgent)) {
            return true;
        }
        if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
            return true;
        }
        return false;
    }

    public getIsMobile(): boolean {
        return this.isMobile;
    }
}
